import React from 'react';
import { useQZTray } from '../../../../context/QZTrayContext';
import { useTranslation } from '../../../../context/LanguageContext';
import SelectField from '../../../form/SelectField';
import CheckboxField from '../../../form/CheckboxField';
import TextareaField from '../../../form/TextareaField';

const PrintingTab = ({ settings, handleChange }) => {
    const { t, isRTL } = useTranslation();
    const { printers } = useQZTray();

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className={`text-lg font-semibold text-gray-800 mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('admin.printerConfig')}
                </h3>
                <div className="grid grid-cols-1 gap-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <SelectField
                            label={t('admin.printerType')}
                            value={settings.printing.printer_type}
                            onChange={(e) => handleChange('printing', 'printer_type', e.target.value)}
                            options={[
                                { value: 'thermal', label: t('admin.thermal') },
                                { value: 'dot_matrix', label: t('admin.dotMatrix') },
                                { value: 'inkjet', label: t('admin.inkjet') }
                            ]}
                        />
                        <SelectField
                            label={t('admin.paperSize')}
                            value={settings.printing.paper_size}
                            onChange={(e) => handleChange('printing', 'paper_size', e.target.value)}
                            options={[
                                { value: '80mm', label: '80mm' },                                
                                { value: '72mm', label: '72mm' },
                                { value: '58mm', label: '58mm' }
                            ]}
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <SelectField
                            label={t('admin.paperHeight')}
                            value={settings.printing.paper_height || '3276'}
                            onChange={(e) => handleChange('printing', 'paper_height', e.target.value)}
                            options={[
                                { value: 'auto', label: t('admin.autoHeight') },
                                { value: '3276', label: '3276.00mm (Continuous)' },
                                { value: '297', label: '297.00mm' },
                                { value: '210', label: '210.00mm' }
                            ]}
                        />
                        <SelectField
                            label={t('admin.fontSize')}
                            value={settings.printing.font_size}
                            onChange={(e) => handleChange('printing', 'font_size', e.target.value)}
                            options={[
                                { value: '6', label: '6px' },
                                { value: '8', label: '8px' },
                                { value: '10', label: '10px' },
                                { value: '12', label: '12px' },
                                { value: '14', label: '14px' }
                            ]}
                        />
                        <SelectField
                            label={t('admin.printCopies')}
                            value={settings.printing.copies || '1'}
                            onChange={(e) => handleChange('printing', 'copies', e.target.value)}
                            options={[
                                { value: '1', label: '1' },
                                { value: '2', label: '2' },
                                { value: '3', label: '3' },
                                { value: '4', label: '4' },
                                { value: '5', label: '5' }
                            ]}
                        />
                        <SelectField
                            label={t('admin.printerName')}
                            value={settings.printing?.printer_name || ''}
                            onChange={(e) => {
                                const printerName = e.target.value;

                                // Update the printer name directly
                                handleChange('printing', 'printer_name', printerName);
                            }}
                            options={[
                                { value: '', label: t('admin.selectPrinter') },
                                ...printers
                            ].filter(Boolean)}
                        />
                        {/* Debug output */}
                        <div className="text-sm text-gray-500">
                            Current printer: {settings.printing.printer_name || 'Not set'}
                        </div>
                        <div className="space-y-4">
                            <CheckboxField
                                label={t('admin.showLogo')}
                                checked={settings.printing.show_logo}
                                onChange={(e) => handleChange('printing', 'show_logo', e.target.checked)}
                            />
                            <CheckboxField
                                label={t('admin.autoPrint')}
                                checked={settings.printing.auto_print}
                                onChange={(e) => handleChange('printing', 'auto_print', e.target.checked)}
                            />
                            <CheckboxField
                                label={t('admin.openDrawerAfterPrint')}
                                checked={settings.printing.open_drawer_after_print}
                                onChange={(e) => handleChange('printing', 'open_drawer_after_print', e.target.checked)}
                            />
                        </div>
                    </div>
                </div>
                {/* QZ Tray Certificate Configuration */}
                <div className="mt-8">
                    <h4 className={`text-md font-semibold text-gray-800 mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                        {t('admin.qzTrayConfig')}
                    </h4>
                    <div className="grid grid-cols-1 gap-6">
                        <TextareaField
                            label={t('admin.certificate')}
                            value={settings.printing.certificate || ''}
                            onChange={(e) => handleChange('printing', 'certificate', e.target.value)}
                            placeholder="-----BEGIN CERTIFICATE-----\n..."
                            rows={6}
                        />
                        <TextareaField
                            label={t('admin.privateKey')}
                            value={settings.printing.private_key || ''}
                            onChange={(e) => handleChange('printing', 'private_key', e.target.value)}
                            placeholder="-----BEGIN PRIVATE KEY-----\n..."
                            rows={6}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrintingTab;
